import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, MessageCircle, ExternalLink } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";
import { CONTACT } from "../../lib/constants";

export const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="bg-accent-dark text-white py-20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-center text-center md:text-left">
          <div>
            <p className="font-serif text-2xl md:text-3xl tracking-tight">
              Click <span className="italic text-gold">Photography</span>
            </p>
            <p className="text-xs tracking-[0.2em] uppercase text-white/55 mt-3">
              {t.footer.tagline}
            </p>
          </div>

          <div className="grid grid-cols-2 gap-x-6 gap-y-4 md:flex md:justify-center md:gap-8 max-w-xs mx-auto md:max-w-none">
            <a
              href={CONTACT.instagram}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram"
              className="flex items-center gap-2 text-sm text-white/70 hover:text-gold transition-colors"
            >
              <Instagram size={16} /> {t.footer.links.instagram}
            </a>
            <a
              href={CONTACT.facebook}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-facebook"
              className="flex items-center gap-2 text-sm text-white/70 hover:text-gold transition-colors"
            >
              <Facebook size={16} /> Facebook
            </a>
            <a
              href={CONTACT.whatsappLink}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp"
              className="flex items-center gap-2 text-sm text-white/70 hover:text-gold transition-colors"
            >
              <MessageCircle size={16} /> {t.footer.links.whatsapp}
            </a>
            <a
              href={CONTACT.bookingForm}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-booking"
              className="flex items-center gap-2 text-sm text-white/70 hover:text-gold transition-colors"
            >
              <ExternalLink size={16} /> {t.footer.links.booking}
            </a>
          </div>

          <div className="md:text-right">
            <p className="text-xs text-white/50">
              © {year} Click Photography
            </p>
            <p className="text-xs text-white/40 mt-2">
              {t.footer.rights}
            </p>
            <p className="text-xs text-white/40 mt-1">
              {CONTACT.instagramHandle}
            </p>
            <Link
              to="/privacy"
              data-testid="footer-privacy"
              className="inline-block text-xs text-white/55 hover:text-gold transition-colors mt-3 underline-offset-4 hover:underline"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
